<script>
    import { format } from 'svelte-i18n';
    let {references} = $props();
    let vulnerabilityReferencesShown = $state(false);
</script>
<style>

.references-list{
    line-height: 1.5;
    padding: 1em;
}

</style>
{#if references.length}
    {#if references.length < 6 || vulnerabilityReferencesShown }
        <ul class="references-list">
            {#each references as reference, i}
                <li class="mb-2"><a href="{reference}" target="_blank" referrerpolicy="origin">{reference}</a></li>
            {/each}
        </ul>
        {#if vulnerabilityReferencesShown }
            <button type="button" class="btn btn-xs btn-default" title={$format("hide")} on:click={() => vulnerabilityReferencesShown = false}>{$format("buttons.see_less")}</button>
        {/if}
    {:else}
        <ul class="references-list">
            {#each references.slice(0,5) as reference, i}
                <li class="mb-2"><a href="{reference}" target="_blank" referrerpolicy="origin">{reference}</a></li>
            {/each}
        </ul>
        {#if references.length >= 6 }
            <button type="button" class="btn btn-xs btn-default" title={$format("show")} on:click={() => vulnerabilityReferencesShown = true}>{$format("buttons.see_more")}</button>
        {/if}
    {/if}
{/if}